<template>
  <div
    class="afterEval communityEvaluation bigBox communityProduct"
    :style="allow_scroll ? {} : { height: '100%', overflow: 'hidden' }"
  >
    <!--    <header>-->
    <!--      <button class="close">取消</button>-->
    <!--      <button class="fb">发布</button>-->
    <!--    </header>-->
    <article>
      <div class="evalPhotoBox">
        <!--<ul class="evalPhoto">-->
        <!--<li><img src="../../assets/images/add.png"></li>-->
        <!--</ul>-->
        <div
          v-if="fileVideoList && fileVideoList.length && fileVideoList[0].content"
          class="image van-uploader"
        >
          <div class="van-uploader__wrapper">
            <div
              class="van-uploader__upload"
              :class="{ fullscreen: isfullscreen }"
              style="position: relative;width: 1.05rem;height: 1.05rem;background: #333333;"
            >
              <video
                @click="playFn"
                crossOrigin="anonymous"
                class="videofile"
                id="videofile"
                :src="fileVideoList[0].content"
                @loadeddata="loadedmetadata"
                webkit-playsinline="true"
                playsinline="true"
                x5-playsinline="true"
                x-webkit-airplay="allow"
                preload="true"
              >
                <source :src="fileVideoList[0].content" type="video/mp4" />
                您的浏览器不支持 video 标签。
              </video>
              <div
                v-if="poster.length > 0"
                style="
                width: 1.05rem;
                height: 1.05rem;
                display: flex;
                justify-content: center;
                align-items: center;background: #333333;"
                class="van-uploader__preview-image play"
              >
                <img style="width: 100%;" @click="playFn" :src="poster[0].content" />
              </div>
              <img
                @click="playFn"
                v-if="!isfullscreen"
                src="/static/images/community/video.png"
                class="play"
              />
              <i
                class="van-icon van-icon-clear van-uploader__preview-delete"
                @click="
                  fileVideoList = []
                  poster = []
                "
              ></i>
              <button class="poster">{{ poster.length > 0 ? '更换封面' : '添加封面' }}</button>
              <van-uploader v-if="!isfullscreen" v-model="poster" class="poster-upload">
                <button class="poster"></button>
              </van-uploader>
            </div>
          </div>
        </div>
        <van-uploader
          v-if="!(fileVideoList && fileVideoList.length && fileVideoList[0].content)"
          class="image"
          :multiple="true"
          v-model="fileList"
          :max-count="9"
          preview-size="1.05rem"
          :after-read="afterReadFile"
        />
        <van-uploader
          v-if="
            !(fileList && fileList.length) &&
              !(fileVideoList && fileVideoList.length && fileVideoList[0].content)
          "
          class="video"
          :compressed="false"
          v-model="fileVideoList"
          :max-count="1"
          accept="video/*"
          preview-size="1.05rem"
          :before-read="beforeRead"
          :after-read="afterRead"
        />
        <!--        <span v-if="isWeixinShow && !(fileVideoList && fileVideoList.length && fileVideoList[0].content)">上传视频时长最短10秒,最长3分钟</span>-->
        <input
          type="text"
          v-model="title"
          id="title"
          maxlength="20"
          placeholder="填写标题会有更多赞哦~"
        />
      </div>
      <textarea
        v-model="textinput"
        name=""
        id="afterEval"
        :placeholder="
          $route.query.pathType == 'newpro'
            ? '快来写下您的试用体验~优质内容还可获得官方助力！'
            : '记录每一天的好心情，不得少于15字呦！'
        "
        @blur="input_blur"
      ></textarea>
      <!--      <p>{{textNum}}/200</p>-->
      <div
        class="topic f14"
        :class="{ topic1: $store.state.chooseTopic && $store.state.chooseTopic.subject }"
        @click="gotopic"
      >
        {{ $store.state.chooseTopic ? $store.state.chooseTopic.subject : '参与话题' }}
        <van-icon
          v-if="$route.query.pathType != 'newpro' && poststype != 2"
          name="arrow"
          size="0.145rem!important"
          color="#1D1E1E"
        />
      </div>
    </article>
    <div class="contactproduct contactproduct2" style="margin-bottom: 0.1rem">
      <div class="contact" @click="goProductlist">
        <div class="contactTitle">
          <b class="f14">关联商品</b>
        </div>
        <van-icon
          v-if="
            !(
              $route.query.pathType == 'newpro' ||
              ($store.state.chooseTopic && $store.state.chooseTopic.isupdate_product == 0)
            )
          "
          name="arrow"
          size="0.145rem!important"
          color="#1D1E1E"
        />
      </div>
      <div
        class="list"
        v-if="
          $store.state.chooseCrossSellProductItem &&
            $store.state.chooseCrossSellProductItem.length > 0
        "
      >
        <div class="scroll">
          <ul>
            <li
              class="flex-s"
              :class="{ itemWidth: $store.state.chooseCrossSellProductItem.length >= 2 }"
              v-for="(item, index) of $store.state.chooseCrossSellProductItem"
            >
              <van-icon
                v-if="
                  !(
                    $route.query.pathType == 'newpro' ||
                    ($store.state.chooseTopic && $store.state.chooseTopic.isupdate_product == 0)
                  )
                "
                class="close"
                name="clear"
                size="0.14rem!important"
                @click.stop="closeFn(index)"
                color="#C4C4C4"
              />
              <img v-lazy="item.img_path" />
              <div class="name">
                <p class="f12 over-ell-2">{{ item.name }}</p>
                <p class="f12 price">
                  ¥{{ item.sales_price }}
                  <span class="f10">¥{{ item.cost_price }}</span>
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="iscreator != 0" class="contact list switch" style="padding-top: 0.15rem">
        <div class="contactTitle">
          <b class="f14">帖子打赏</b>
        </div>
        <van-switch size="0.2rem" v-model="checked" />
      </div>
    </div>
    <div class="rule">
      <span class="f12" @click="ruleFn(rule_1)">
        <img width="12" height="12" src="/static/images/community/fb.png" />
        发布须知
      </span>
      <span class="f12" @click="ruleFn(rule_2)">
        <img width="10" height="12" src="/static/images/community/jl.png" />
        奖励政策
      </span>
    </div>
    <div class="footer footerIOS">
      <button v-if="!issue" class="save" @click="submit(0)">
        <img src="/static/images/community/preservation.png" />
      </button>
      <button class="submit" @click="submit(1)">发布</button>
    </div>
    <!--    <div class="deleteImg footer">-->
    <!--      删除-->
    <!--    </div>-->
  </div>
</template>

<script>
import { isWeixin, fenxiang, encryption } from '../../assets/common/js/config'

export default {
  name: 'communityEvaluation',
  data() {
    return {
      fileVideoList: [], // 视频file
      fileList: [], // 图片封面file
      fileLen: null,
      poster: [], // 视频封面file
      imgpath: [], // 图片地址
      videopath: '', // 视频地址
      videoposter: '', // 视频封面
      isfullscreen: false,
      textinput: '',
      title: '',
      textNum: 0,
      showDeleteArea: false,
      isWeixinShow: false,
      issue: 0,
      poststype: 1,
      checked: false,
      iscreator: 0,
      rule_1: {
        title: '创客云商社区规范',
        content:
          '亲爱的金粉宝宝，欢迎来到创客云商社区！社区鼓励原创、真实产品使用体验与日常分享，金币奖励仅为优质原创内容激励，并非发帖条数福利，严禁以灌水、重复凑数等方式恶意刷取金币套利。为保护原创者权益以及内容社区整体氛围，您需要了解并遵守以下规范：\n' +
          '用户发布和传播内容、参与互动，应当符合本规范的要求。平台将依据本规范的条款对金粉及金粉发布的内容进行管理。\n' +
          '违规行为界定\n' +
          '(一) 违反法律法规\n' +
          '(1) 违反宪法所确定的基本原则的；\n' +
          '(2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；\n' +
          '(3) 使用或者变相使用国家机关、国家机关工作人员的名义或者形象\n' +
          '(4) 损害国家荣誉和利益的；\n' +
          '(5) 歪曲、丑化、亵渎、否定英雄烈士及其事迹和精神的，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；\n' +
          '(6) 宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的\n' +
          '(7) 煽动民族仇恨、民族歧视，破坏民族团结的\n' +
          '(8) 破坏国家宗教政策，宣扬邪教和封建迷信的\n' +
          '(9) 散布虚假信息，扰乱社会秩序，破坏社会稳定的；\n' +
          '(10) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；\n' +
          '(11) 侮辱或者诽谤他人，侵害他人名誉、隐私、知识产权或其他合法权益的；\n' +
          '(12) 带有性暗示、性挑逗等易使人产生性联想的；\n' +
          '(13) 展现血腥、惊悚、残忍等致人身心不适的\n' +
          '(14) 炒作绯闻、丑闻、劣迹等的\n' +
          '(15) 宣扬低俗、庸俗、媚俗内容的；\n' +
          '(16) 不当评述自然灾害、重大事故等灾难的；\n' +
          '(17) 煽动人群歧视、地域歧视等的；\n' +
          '(18) 使用夸张标题，内容与标题严重不符的；\n' +
          '(19) 可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的；\n' +
          '(20) 其他对网络生态造成不良影响的内容；\n' +
          '(21) 含有法律、行政法规禁止的其他内容的。\n' +
          '(二) 不友善行为:\n' +
          '(1) 轻蔑：贬低、轻视他人及其劳动成果；\n' +
          '(2) 诽谤：捏造、散布虚假事实，损害他人名誉\n' +
          '(3) 嘲讽：以比喻、夸张、侮辱性的手法对他人或其行为进行揭露或描述，以此来激怒他人；\n' +
          '(4) 挑衅：以不友好的方式激怒他人，意图使对方对自己的言论做出回应，蓄意制造事端；\n' +
          '(5) 羞辱：贬低他人的能力、行为、生理或身份特征，让对方难堪；\n' +
          '(6) 谩骂：以不文明的语言对他人进行负面评价\n' +
          '(7) 歧视：针对他人的民族、种族、宗教、性取向、性别、年龄、地域、生理特征等身份或者归类的攻击；\n' +
          '(8) 威胁：以不良的后果来迫使他人服从自己的意志。\n' +
          '(三) 发布垃圾信息:\n' +
          '(1) 重复发布相似内容；\n' +
          '(2) 发布包含售卖产品、提供服务、宣传推广内容的垃圾广告；\n' +
          '(3) 购买或出售账号之间虚假地互动，发布干扰社区秩序的推广内容及相关交易；\n' +
          '(4) 发布与主题不相关的讨论内容及话题；\n' +
          '(5) 使用严重影响用户体验的违规手段进行恶意营销；\n' +
          '(6) 使用特殊符号、图片等方式规避垃圾广告内容审核的广告内容。\n' +
          '(7) 恶意刷帖套利：为获取社区发帖金币奖励，发布纯表情、极短无意义文字、复制粘贴文案、高度重复内容、空洞凑数帖，批量刷每日发帖任务套取金币的行为；\n' +
          '(8) 低质无效内容：无真实产品体验、无个人日常感悟，仅简单短句/无意义字符堆砌的灌水内容，此类内容不计入有效发帖奖励统计，复审下架后奖励的金币将被回收。\n' +
          '(四) 恶意行为:\n' +
          '(1) 冒充他人，通过头像、用户名等个人信息暗示自己与他人或机构相等同或有关联；\n' +
          '(2) 骚扰他人，以评论、私信等方式对他人反复发送重复或者相似的诉求；\n' +
          '(3) 发布含有钓鱼网站、木马、病毒网站链接及相关内容；\n' +
          '(4) 发布含有潜在危险、窃取用户隐私等相关内容\n' +
          '(5) 抄袭他人，在未经原作者合法授权使用相关内容\n' +
          '(五) 违反未成年人合法权益\n' +
          '(1) 发布涉及未成年人色情低俗的，如展示未成年人婚育、性侵害等；\n' +
          '(2) 发布涉及未成年人暴力欺凌的，如施暴犯罪残害体罚、校园欺凌等；\n' +
          '(3) 发布涉及披露未成年人隐私的，如展示未成年人性器官，公开个人隐私等；\n' +
          '(4) 发布涉及未成年人不良行为的，如宗教传授、饮酒吸烟、邪典动画等；\n' +
          '(5) 发布涉及规避未成年人系统监管的，如故意规避防沉迷、青少年模式的方法攻略；\n' +
          '(6) 发布其他危害未成年人安全和健康的相关内容\n' +
          '(六) 侵权行为:\n' +
          '创客云商禁止一切侵犯他人合法权益的行为，如模仿冒充、抄袭，包括但不限于以下内容:\n' +
          '(1) 姓名权、肖像权、名誉权及隐私权\n' +
          'a 未经授权使用信息，冒充他人注册账号或使用他人名称、头像等；\n' +
          'b 通过发布不实言论，散播虚假信息，损害他人名誉、商誉的内容；\n' +
          'c. 未经授权发布他人身份证号码、家庭住址、病史、财产信用状况等个人隐私资料。\n' +
          '(2) 知识产权及其他权利\n' +
          'a 未经他人授权，发布内容侵犯他人著作权权益，如视频，照片，图文等；\n' +
          'b 侵犯他人已经登记注册的企业名称、商标、商号、商品装潢等；\n' +
          'c 未经他人授权，发布内容侵犯他人专利权权益等；\n' +
          'd. 未经授权披露商业机密或其他保密信息的内容\n' +
          'e 发布内容用以蓄意传播假冒伪劣商品信息。\n' +
          '二、其他创客云商界定为违规的内容\n' +
          '1、用户账号使用规范\n' +
          '(1) 用户账号是用户在社区的“通行证”，登录账号后可以在平台自定义用户信息、发布图文/视频笔记，发送评论等。 用户账号使用者应当遵守法律法规，遵循公序良俗，弘扬社会主义核心价值观，依法依规进行账号名称信息注册、使用、管理。\n' +
          '2、用户信息规范\n' +
          '用户在使用自定义功能、个性化自己的信息时 (包括用户昵称、个性签名、用户头像等)，请遵守国家相关法律、法规，不得含有违规信息，包括但不限于以下内容:\n' +
          '(1) 假冒、仿冒、捏造党政军机关、企事业单位和人民团体等组织机构的名称、标识的；\n' +
          '(2) 假冒、仿冒、捏造新闻媒体的名称、标识，或擅自使用新闻、报道、报刊等具有新闻属性的名称信息的；\n' +
          '(3) 假冒、仿冒、关联国家行政区域、机构所在地，标志性建筑物等重要空间的地理名称的\n' +
          '(4) 故意夹带二维码、网址、邮箱、联系方式等，或者使用同音、谐音、相近文字，拼音、数字、符号、字母和无意义文字等侵犯他人合法权益、谋取非法利益或者损害公共利益的；\n' +
          '(5) 法律、行政法规禁止的其他行为。\n' +
          '三、违规处理\n' +
          '(一) 违规处理措施\n' +
          '任何发布在社区的笔记及相关言论，平台有权根据国家现行法律法规、道德准则及本规范进行界定。\n' +
          '违规处理方式\n' +
          '发现违法违规用户及相关信息，平台将有权禁止展示相关信息或删除相关信息，并对用户采取警示提醒、限期改正、限制账号功能、暂停使用、关闭账号、禁止重新注册等处置措施。\n' +
          '1.系统前置拦截：纯表情、字数过短、短时间重复发帖将直接拦截发布，不计入每日发帖任务、不发放金币；\n' +
          '2.人工复核处置：帖子发布后经复核判定为灌水刷金币垃圾帖，平台可直接下架帖子，同步回收该条帖子已发放的对应金币，金币明细将标注「社区发帖回收」扣减记录；\n' +
          '3.梯度处罚：\n' +
          '·首次轻度刷帖：帖子下架、警告、回收对应金币；\n' +
          '·多次违规刷帖：执行1–365天或永久社区禁言，禁言期间无法发帖获取金币，账号购物功能不受影响；\n' +
          '对于情节严重者平台将向网信、公安机关等有关主管部报告并提供相关内容和线索。\n' +
          '(二) 投诉/申诉\n' +
          '如果用户发现社区中含有违规信息或者认为其他用户侵犯了您的合法权益，所有用户均可以通过联系官方客服进行投诉 / 申诉，我们将会及时予以处理。'
      },
      rule_2: {
        title: '奖励制度',
        content:
          '1. 每发布一条内容可奖励20金币(每天限奖励前两条发布内容)\n' +
          '2. 单条内容点赞数超过100，可获得20金币奖励\n' +
          '3. 单条内容收藏数超过20，可获得20金币奖励\n' +
          '4. 单条内容评论数超过20，可获得20金币奖励\n' +
          '*奖励制度是为了鼓励大家踊跃发言，活跃社区氛围，若出现随意刷帖或者恶意刷金币的行为，后台将进行禁言和收回金币'
      },
      allow_scroll: true
    }
  },
  mounted: function() {
    if (isWeixin()) fenxiang({ path: 'communitycenter' })
    this.issue = this.$route.query.issue ? this.$route.query.issue : 0
    console.log('mounted')
    // this.mountedFn()
  },
  beforeRouteEnter(to, from, next) {
    console.log(to, from)
    if (from.path == '/communitytopic' || from.path == '/crosssellproducts') {
      next((vm) => {
        vm.issue = vm.$route.query.issue ? vm.$route.query.issue : 0
        vm.$forceUpdate()
      })
    } else {
      next((vm) => {
        Object.assign(vm.$data, vm.$options.data())
        vm.issue = vm.$route.query.issue ? vm.$route.query.issue : 0
        vm.mountedFn()
      })
    }
  },
  destroyed: function() {
    this.$toast.clear()
    this.$dialog.close()
  },
  watch: {
    $router: {
      handler(val) {
        console.log(val)
      }
    },
    // textinput (n) {
    //   if (n.length > 200) {
    //     this.textNum = 200
    //   } else {
    //     this.textNum = n.length
    //   }
    //   this.textinput = this.textinput.slice(0, 200)
    //   console.log(n.length)
    // },
    poster(n) {
      if (n.length > 1) {
        this.poster.splice(0, 1)
      }
      console.log('poster', n)
    }
  },
  methods: {
    getData() {
      if (this.$route.query.id && this.$route.query.type != 'crosscell') {
        var url = this.$ajax.getPostsDetail_URL + '?itemid=' + this.$route.query.id
        this.$customRequestAjax(url).then((res) => {
          if (res.data.code == 200) {
            console.log(res)
            this.checked = res.data.data.isreward == 1 ? true : false
            this.poststype = res.data.data.poststype ? res.data.data.poststype : 1
            res.data.data.images.map((item) => {
              this.fileList.push({
                url: item
              })
            })
            this.title = res.data.data.title ? res.data.data.title : ''
            this.textinput = res.data.data.content
            this.fileVideoList = res.data.data.videourl ? [{ content: res.data.data.videourl }] : []
            this.poster = res.data.data.coverimg ? [{ content: res.data.data.coverimg }] : []
            let topic = res.data.data.subjectid
              ? {
                  subject: res.data.data.subject,
                  subjectid: res.data.data.subjectid,
                  isupdate_product: res.data.data.isupdate_product
                }
              : null
            let associateditem = res.data.data.productlist ? res.data.data.productlist : []
            this.$store.commit('CHOOSE_TOPIC', topic)
            this.$store.commit('CHOOSE_CROSS_SELL_PRODUCT_ITEM', associateditem)
            console.log(
              '1',
              this.$store.state.chooseTopic,
              this.$store.state.chooseCrossSellProductItem
            )
          }
        })
      }
    },
    creator() {
      var url = this.$ajax.getCommunityUserIscreator_URL
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code == 200) {
          this.iscreator = res.data.iscreator
        }
      })
    },
    mountedFn() {
      if (isWeixin()) {
        fenxiang({ path: 'productevaluation' })
        this.isWeixinShow = true
      }
      this.creator()
      this.getData()
    },
    closeFn(index) {
      var chooseCrossSellProductItem = this.$store.state.chooseCrossSellProductItem
      chooseCrossSellProductItem.splice(index, 1)
      this.$store.commit('CHOOSE_CROSS_SELL_PRODUCT_ITEM', chooseCrossSellProductItem)
    },
    playFn: function() {
      this.isfullscreen = !this.isfullscreen
      if (this.isfullscreen) {
        document.getElementById('videofile').play()
      } else {
        document.getElementById('videofile').pause()
      }
    },
    afterRead: function() {
      this.$nextTick(function() {
        const video = document.getElementById('videofile')
        video.load()
      })
    },
    beforeRead: function(file) {
      console.log(file)
      var that = this
      return new Promise(function(resolve, reject) {
        var fileUrl = URL.createObjectURL(file)
        var audioElement = new Audio(fileUrl)
        var duration
        if (isWeixin()) {
          resolve()
        } else {
          f()
        }
        function f() {
          audioElement.addEventListener('loadedmetadata', function(event) {
            duration = audioElement.duration
            if (duration <= 10) {
              that.$toast('视频最短要10秒哦！')
              reject()
            } else if (duration / 60 > 3) {
              that.$toast('视频内容不能超过3分钟哦！')
              reject()
            }
            resolve()
          })
        }
      })
    },
    loadedmetadata: function() {
      const video = document.getElementById('videofile')
      console.log(video.duration)
    },
    afterReadFile: function(file) {
      // console.log('afterReadFile', file)
      setTimeout(() => {
        this.addTouchEvent()
      })
    },
    addTouchEvent: function() {
      let domlist = document.querySelectorAll('.van-uploader__preview'),
        touchStartTime,
        that = this
      if (domlist) {
        let domMoveFlag = true
        domlist.forEach((item, index) => {
          item.ontouchstart = null
          item.ontouchmove = null
          item.ontouchend = null
          item.ontouchstart = (startEvent) => {
            that.allow_scroll = false
            // console.log(startEvent)
            if (startEvent.currentTarget.className.indexOf('van-uploader__preview') < 0) return
            // startEvent.preventDefault()
            touchStartTime = new Date()
            setTimeout(() => {
              if (domMoveFlag) {
                // console.log('执行元素位置操作过程')
                that.showDeleteArea = true
                let domClient = item.getBoundingClientRect()
                // console.log('domClient', domClient)
                let firstPosition = {
                  x: startEvent.changedTouches[0].pageX,
                  y: startEvent.changedTouches[0].pageY
                }
                item.style.position = 'fixed'
                item.style.top = domClient.top / 100 + 'rem'
                item.style.left = domClient.left / 100 + 'rem'
                item.style.zIndex = 9
                // 添加拖拽事件
                item.ontouchmove = (moveEvent) => {
                  if (moveEvent.currentTarget.className.indexOf('van-uploader__preview') < 0) return
                  let time = new Date()
                  if (time - touchStartTime > 600) {
                    item.style.top =
                      (moveEvent.changedTouches[0].pageY - firstPosition.y + domClient.top) / 100 +
                      'rem'
                    item.style.left =
                      (moveEvent.changedTouches[0].pageX - firstPosition.x + domClient.left) / 100 +
                      'rem'
                    // console.log('top', item.style.top, moveEvent.changedTouches[0].pageY, firstPosition.y, domClient.top)
                    // console.log('left', item.style.left, moveEvent.changedTouches[0].pageX, firstPosition.x, domClient.left)
                  }
                }
              }
            }, 600)
          }
          item.ontouchend = (endEvent) => {
            that.allow_scroll = true
            if (endEvent.currentTarget.className.indexOf('van-uploader__preview') < 0) return
            let time = new Date()
            // console.log(time - touchStartTime)
            if (time - touchStartTime <= 400) {
              domMoveFlag = false
              item.click()
              setTimeout(() => {
                that.addTouchEvent()
              })
            } else {
              let newItemCenter = item.getBoundingClientRect(),
                centerY = newItemCenter.top + newItemCenter.height / 2,
                centerX = newItemCenter.left + newItemCenter.width / 2
              // deleteDom = document.querySelector('.deleteImg'),
              // deleteArea = deleteDom.getBoundingClientRect()
              // if (centerY >= deleteArea.top) {
              //   let _imgList = JSON.parse(JSON.stringify(that.fileList))
              //   let currentImg = _imgList.splice(index, 1)
              //   that.fileList = []
              //   that.showDeleteArea = false
              //   setTimeout(() => {
              //     that.fileList = _imgList
              //     console.log(that.fileList)
              //     setTimeout(() => {
              //       that.addTouchEvent()
              //     })
              //   })
              //   return
              // }
              that.showDeleteArea = false
              // 计算所有图片元素所在页面位置
              let domParentList = document.querySelectorAll('.van-uploader__preview')
              domParentList &&
                domParentList.forEach((domParent, cindex) => {
                  let domPos = domParent.getBoundingClientRect()
                  if (
                    centerY >= domPos.top &&
                    centerY <= domPos.bottom &&
                    centerX >= domPos.left &&
                    centerX <= domPos.right
                  ) {
                    // 重新排序
                    console.log('在目标区域内，重新排序')
                    let _imgList = JSON.parse(JSON.stringify(that.fileList))
                    let currentImg = _imgList.splice(index, 1)
                    _imgList.splice(cindex, 0, ...currentImg)
                    that.fileList = []
                    console.log(cindex, _imgList, currentImg)
                    that.fileList = _imgList
                    that.addTouchEvent()
                  }
                })
              // 还原样式
              item.style.position = 'relative'
              item.style.top = 'auto'
              item.style.left = 'auto'
              item.style.zIndex = 1
            }
          }
        })
      }
    },
    // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
    cosUploadImage(filllist, file, index, format, type, fn) {
      console.log(file)
      var that = this
      if (
        (file.url && file.url.indexOf('https://') >= 0) ||
        (file.content && file.content.indexOf('https://') >= 0)
      ) {
        index++
        var path = file.url
          ? file.url.replace('Uploads/', '')
          : file.content.replace('Uploads/', '')
        // video
        // videoposter
        // imgpath
        if (type == 'imgpath' || type == 'videoposter') {
          path = file.url ? file.url.split('Uploads/')[1] : file.content.split('Uploads/')[1]
        } else {
          path = file.content
        }
        if (type == 'imgpath') {
          this.imgpath.push(path)
        } else if (type == 'video') {
          this.videopath = path
        } else if (type == 'videoposter') {
          this.videoposter = path
        }
        if (index >= filllist.length) {
          if (typeof fn === 'function') {
            fn()
          }
        } else {
          this.cosUploadImage(filllist, filllist[index], index, format, type, function() {
            if (typeof fn === 'function') {
              fn()
            }
          })
        }
        return
      }
      that.$cos.uploadFile({
        key: '/communityevaluation_h5' + file.file.name,
        file: file.file,
        success: function(data) {
          if (type == 'imgpath') {
            that.imgpath.push(data)
          } else if (type == 'video') {
            that.videopath = data
          } else if (type == 'videoposter') {
            that.videoposter = data
          }
          index++
          if (index >= filllist.length) {
            if (typeof fn === 'function') {
              fn()
            }
          } else {
            that.cosUploadImage(filllist, filllist[index], index, format, type, function() {
              if (typeof fn === 'function') {
                fn()
              }
            })
          }
        }
      })
    },
    // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End
    uploadImage(filllist, file, index, format, type, fn) {
      console.log(file)
      if (
        (file.url && file.url.indexOf('https://') >= 0) ||
        (file.content && file.content.indexOf('https://') >= 0)
      ) {
        index++
        var path = file.url
          ? file.url.replace('Uploads/', '')
          : file.content.replace('Uploads/', '')
        // video
        // videoposter
        // imgpath
        if (type == 'imgpath' || type == 'videoposter') {
          path = file.url ? file.url.split('Uploads/')[1] : file.content.split('Uploads/')[1]
        } else {
          path = file.content
        }
        if (type == 'imgpath') {
          this.imgpath.push(path)
        } else if (type == 'video') {
          this.videopath = path
        } else if (type == 'videoposter') {
          this.videoposter = path
        }
        if (index >= filllist.length) {
          if (typeof fn === 'function') {
            fn()
          }
        } else {
          this.uploadImage(filllist, filllist[index], index, format, type, function() {
            if (typeof fn === 'function') {
              fn()
            }
          })
        }
        return
      }
      var imgName = 'comments'
      var blob = this.dataURLtoBlob(file.content)
      var newFile = this.blobToFile(blob, imgName)
      var url = this.$ajax.getOssWeb_URL
      var that = this
      that.$customRequestAjax(url).then(async (res) => {
        if (res.data.code === 200) {
          const { accessid, host, policy, signature, dir } = res.data.data
          const fd = new FormData()
          let str = that.random_string(16) + newFile.name + format
          fd.append('OSSAccessKeyId', accessid)
          fd.append('policy', policy)
          fd.append('Signature', signature)
          fd.append('key', `${dir}${str}`)
          fd.append('Filename', `${dir}${str}`)
          fd.append('success_action_status', 200)
          fd.append('file', newFile)
          let config = {
            // 添加请求头
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
          that.$axios.post(host, fd, config).then((res) => {
            if (res.status == 200 && res.statusText == 'OK') {
              // var img = that.imgUrl + `${dir}${str}`
              var path = `${dir}${str}`.replace('Uploads/', '')
              if (type == 'imgpath') {
                that.imgpath.push(path)
              } else if (type == 'video') {
                that.videopath = path
              } else if (type == 'videoposter') {
                that.videoposter = path
              }
              index++
              if (index >= filllist.length) {
                if (typeof fn === 'function') {
                  fn()
                }
              } else {
                that.uploadImage(filllist, filllist[index], index, format, type, function() {
                  if (typeof fn === 'function') {
                    fn()
                  }
                })
              }
            }
          })
        }
      })
    },
    gotopic: function() {
      if (this.$route.query.pathType == 'newpro' || this.poststype == 2) return
      if (this.$route.query.id) {
        this.$router.push({
          path: '/communitytopic',
          query: {
            id: this.$route.query.id
          }
        })
      } else {
        this.$router.push({
          path: '/communitytopic'
        })
      }
    },
    goProductlist: function() {
      if (
        this.$route.query.pathType == 'newpro' ||
        (this.$store.state.chooseTopic && this.$store.state.chooseTopic.isupdate_product == 0)
      )
        return
      if (this.$route.query.id) {
        this.$router.push({
          path: '/crosssellproducts',
          query: {
            id: this.$route.query.id
          }
        })
      } else {
        this.$router.push({
          path: '/crosssellproducts'
        })
      }
    },
    // 将base64转换为blob
    dataURLtoBlob: function(dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    // 将blob转换为file
    blobToFile: function(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    random_string: function(n) {
      var num = Math.pow(10, n)
      return Math.ceil(Math.random() * num) + '' + new Date().getTime()
    },
    submit: function(type) {
      this.textinput = this.textinput.replace(/ /g, '')
      this.title = this.title.replace(/ /g, '')
      if (type == 0) {
        if (
          this.textinput == '' &&
          this.fileVideoList.length <= 0 &&
          this.poster.length <= 0 &&
          this.fileList.length <= 0
        ) {
          this.$toast('没有可以保存的内容哦～')
          return
        }
      } else {
        if (this.textinput == '') {
          this.$toast('帖子内容不能为空')
          return
        }
        // if (this.textinput.length < 15) {
        //   this.$toast('内容至少需要15字哦！')
        //   return
        // }
        var chinese_count = (this.textinput.match(/[\u4e00-\u9fa5]/g) || []).length
        if (chinese_count < 15) {
          this.$toast('有效内容至少需要15个中文字符哦')
          return
        }
      }
      this.$toast.loading({
        mask: true,
        message: '正在提交',
        duration: 0
      })
      this.fileLen = 0
      this.imgpath = []
      var that = this
      if (that.fileVideoList.length > 0) {
        // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
        that[that.$cos.isCosSwitch == 1 ? 'cosUploadImage' : 'uploadImage'](
          that.fileVideoList,
          that.fileVideoList[0],
          0,
          '.mp4',
          'video',
          function() {
            if (that.poster.length) {
              that[that.$cos.isCosSwitch == 1 ? 'cosUploadImage' : 'uploadImage'](
                that.poster,
                that.poster[0],
                0,
                '.png',
                'videoposter',
                function() {
                  that.submitAxios(type)
                }
              )
            } else {
              that.submitAxios(type)
            }
          }
        )
        // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End
      } else if (that.fileLen < that.fileList.length) {
        // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
        that[that.$cos.isCosSwitch == 1 ? 'cosUploadImage' : 'uploadImage'](
          that.fileList,
          that.fileList[that.fileLen],
          that.fileLen,
          '.png',
          'imgpath',
          function() {
            that.submitAxios(type)
          }
        )
        // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End
      } else if (that.fileVideoList.length == 0 && that.fileList.length == 0) {
        if (type == 0) {
          that.submitAxios(type)
        } else {
          that.$toast('请上传你的视频/图片')
        }
      }
    },
    submitAxios: function(type) {
      var url = this.$ajax.addPosts_URL
      if (type == 0) {
        url = this.$ajax.addDraft_URL
      }
      var that = this
      // 2024.3.18阿里云迁移-对象存储-动态设置图片参数调整-4 Mod by gaoenhui Start
      var coverimgparams =
        that.$cos.isCosSwitch == 1
          ? '?' + that.$cos.videoLinkParamsStr
          : '?x-oss-process=video/snapshot,t_1000,f_jpg,ar_h'
      // 2024.3.18阿里云迁移-对象存储-动态设置图片参数调整-4 Mod by gaoenhui End
      this.$ckeckgraphic({
        content: that.title + ',' + that.textinput,
        images: that.imgpath.length > 0 ? that.imgpath.join() : '',
        coverimg: that.videoposter
          ? that.videoposter
          : that.videopath
          ? // 2024.3.18阿里云迁移-对象存储-动态设置图片参数调整-4 Mod by gaoenhui Start
            that.videopath + coverimgparams
          : // 2024.3.18阿里云迁移-对象存储-动态设置图片参数调整-4 Mod by gaoenhui End
            '',
        videopath: that.videopath ? that.videopath : '',
        callback: () => {
          var itemlist = []
          if (
            that.$store.state.chooseCrossSellProductItem &&
            that.$store.state.chooseCrossSellProductItem.length > 0
          ) {
            that.$store.state.chooseCrossSellProductItem.map((item) => {
              itemlist.push(item.itemid)
            })
          }
          var data = {
            itemid: that.$route.query.id ? that.$route.query.id : '',
            title: that.title,
            content: that.textinput,
            images: that.imgpath.length > 0 ? JSON.stringify(that.imgpath) : '',
            videopath: that.videopath ? that.videopath : '',
            coverimg: that.videoposter
              ? that.videoposter
              : that.videopath
              ? // 2024.3.18阿里云迁移-对象存储-动态设置图片参数调整-4 Mod by gaoenhui Start
                that.videopath + coverimgparams
              : // 2024.3.18阿里云迁移-对象存储-动态设置图片参数调整-4 Mod by gaoenhui End
                '',
            subjectid: that.$store.state.chooseTopic ? that.$store.state.chooseTopic.subjectid : '',
            subject: that.$store.state.chooseTopic ? that.$store.state.chooseTopic.subject : '',
            goodsitemid: itemlist.join()
          }
          if (that.$route.query.applyid) {
            data.applyid = that.$route.query.applyid
          }
          data.isreward = that.checked ? 1 : 0
          that.$customRequestAjax.post(url, data).then((res) => {
            if (res.data.code === 200) {
              that.$toast.clear()
              that.$dialog.close()
              if (type != 0) {
                if (res.data.status == 1) {
                  that.$dialog
                    .alert({
                      message: res.data.msg,
                      className: 'percen_button_alert integral_button_alert',
                      messageAlign: 'center',
                      confirmButtonColor: '#FFFCFC',
                      confirmButtonText: '我知道了',
                      closeOnPopstate: false
                    })
                    .then(() => {
                      f()
                    })
                    .catch(() => {})
                } else if (res.data.status == 2) {
                  sessionStorage.setItem('communityevaluation_msg', encryption(res.data.msg))
                  that.$router.replace({
                    path: '/communitydetail',
                    query: {
                      id: res.data.id
                    }
                  })
                } else {
                  f()
                }
              } else {
                f()
              }
              function f() {
                if (res.data.pop_img) {
                  sessionStorage.setItem('communityevaluation_pop_img', res.data.pop_img)
                }
                that.$store.commit('CHOOSE_TOPIC', null)
                that.$store.commit('CHOOSE_CROSS_SELL_PRODUCT_ITEM', null)
                that.$store.commit('COMMUNITY_CENTER_TAB', 0)
                that.$store.commit('COMMUNITY_TAB', 0)
                that.$router.replace({
                  path: '/community'
                })
              }
            } else if (res.data.code === 5001 || res.data.code === 500) {
              that.$toast.clear()
              that.$dialog.close()
              that.$dialog
                .alert({
                  title: res.data.code === 500 ? '发布失败' : '',
                  message: res.data.msg,
                  className: 'percen_button_alert integral_button_alert',
                  messageAlign: 'center',
                  confirmButtonColor: '#FFFCFC',
                  confirmButtonText: '知道了',
                  closeOnPopstate: false
                })
                .then(() => {})
                .catch(() => {})
            }
          })
        }
      })
    },
    input_blur() {
      // document.body.scrollTop = document.documentElement.scrollTop - 1
      setTimeout(() => {
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight, 0))
      }, 100)
    },
    handlechange() {
      var reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g
      // var reg = /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g;
      if (this.textinput.match(reg)) {
        this.textinput = this.textinput.replace(reg, '')
      }
      this.textinput = this.textinput.replace(/\s+/g, '')
    },
    ruleFn(obj) {
      this.$dialog
        .alert({
          title: obj.title,
          message: obj.content,
          messageAlign: 'left',
          className: 'percen_button_alert integral_button_alert width_89',
          confirmButtonColor: '#FFFCFC',
          confirmButtonText: '我知道了',
          closeOnPopstate: false
        })
        .then(function() {})
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/common/css/van-switch';
.width_89 {
  width: 89% !important;
}
</style>
<style scoped lang="scss">
@import '../../assets/common/css/productList';
.afterEval {
  article {
    background: #fff;
    margin: 0.1rem 0.11rem 0;
    padding: 0.15rem 0.03rem 0 0.11rem;
    border-radius: 0.04rem;
    .poster {
      background: rgba(0, 0, 0, 0.39) !important;
      border-radius: 0 0 0.03rem 0.03rem;
      border-width: 0;
      font-size: 0.1rem;
      color: #ffffff;
      width: 100%;
      height: 0.22rem;
      line-height: 0.22rem;
      display: block;
      position: absolute;
      left: 0;
      bottom: 0;
    }
    .poster-upload {
      height: 0.22rem;
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
      .poster {
        background: transparent !important;
      }
    }
    #title {
      display: block;
      width: 100%;
      height: 0.4rem;
      border: none;
      outline: none;
      line-height: 0.18rem;
      font-size: 0.13rem;
      color: #333;
      margin-top: 0.1rem;
      padding-right: 0.08rem;
      &::placeholder {
        font-size: 0.13rem;
        color: #b0b0b0;
        line-height: 0.18rem;
      }
    }
    #afterEval {
      display: block;
      width: 100%;
      min-height: 1.43rem;
      border: none;
      outline: none;
      line-height: 0.18rem;
      font-size: 0.13rem;
      color: #333;
      margin-top: 0.1rem;
      padding-right: 0.08rem;
      &::placeholder {
        font-size: 0.13rem;
        color: #b0b0b0;
        line-height: 0.18rem;
      }
    }
    p {
      font-size: 0.11rem;
      color: #b0b0b0;
      text-align: right;
      margin-right: 0.08rem;
    }
    .evalPhotoBox {
      display: flex;
      align-items: flex-end;
      flex-wrap: wrap;
      position: relative;
      padding-bottom: 0.07rem;
      &:after {
        content: '';
        display: block;
        height: 0.005rem;
        width: 98%;
        position: absolute;
        background: #d8d8d8;
        bottom: 0;
      }
      span {
        display: block;
        font-size: 0.11rem;
        color: #b0b0b0;
        /*margin-left: 0.1rem;*/
        margin-bottom: 0.08rem;
      }
    }
    .topic {
      height: 0.4rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: url(/static/images/community/community-topic-default.png) no-repeat left center;
      background-size: 0.18rem 0.18rem;
      padding-left: 0.26rem;
      color: #222222;
      margin-right: 0.08rem;
      margin-top: 0.1rem;
      position: relative;
      &.topic1 {
        background: url(/static/images/community/community-topic-selected.png) no-repeat left center;
        background-size: 0.18rem 0.18rem;
        color: #fc0324;
      }
      &:before {
        content: '';
        display: block;
        height: 0.005rem;
        width: 100%;
        background: #d8d8d8;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
  .contactproduct {
    &.contactproduct1 .contact {
      &:after {
        content: '';
        display: block;
        box-sizing: border-box;
        width: 91%;
        margin: 0 0.15rem;
        height: 0.01rem;
        background: #d8d8d8;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
    &.contactproduct2 .list {
      padding-top: 0;
    }
    .contact {
      margin: 0.1rem 0.11rem 0;
      position: relative;
      /*border-radius: 0.04rem 0.04rem 0 0;*/
    }
    .list {
      margin: 0 0.11rem;
      padding: 0.15rem;
      background: #fff;
      border-radius: 0 0 0.04rem 0.04rem;
      > p {
        color: #6c6c6c;
        font-size: 0.13rem;
        margin: 0 0 0.11rem;
      }
    }
  }
  .contact {
    /*height: 0.45rem;*/
    background: #fff;
    margin: 0.1rem 0.11rem 0.55rem;
    padding: 0.15rem;
    padding-right: 0.11rem;
    display: flex;
    display: -ms-flex;
    display: -webkit-flex;
    display: -moz-flex;
    display: -o-flex;
    align-items: center;
    -webkit-align-items: center;
    -o-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    justify-content: space-between;
    -ms-justify-content: space-between;
    -webkit-justify-content: space-between;
    -moz-justify-content: space-between;
    -o-justify-content: space-between;
    border-radius: 0.04rem;
    &.switch {
      position: relative;
      &:before {
        content: '';
        display: block;
        position: absolute;
        left: 0.15rem;
        right: 0.15rem;
        top: 0;
        height: 0.005rem;
        background: #efefef;
      }
      padding-top: 0.15rem;
    }
    .contactTitle {
      flex: 1;
      -ms-flex: 1;
      -webkit-flex: 1;
      -moz-flex: 1;
      -o-flex: 1;
      b {
        display: block;
        color: #000000;
        margin-right: 0.08rem;
        /*float: left;*/
        line-height: 0.22rem;
      }
      p {
        font-size: 0.11rem;
        font-weight: 400;
        color: rgba(176, 176, 176, 1);
        line-height: 0.17rem;
        margin-top: 0.05rem;
      }
    }
  }
  .rule {
    background: transparent;
    padding: 0.01rem 0.11rem;
    text-align: right;
    font-size: 0;
    span {
      display: inline-block;
      background: transparent;
      margin-left: 0.24rem;
      line-height: 0.12rem;
      color: #338bf6;
      img {
        display: inline-block;
        margin-right: 0.04rem;
        vertical-align: middle;
      }
    }
  }
  .footer {
    display: flex;
    align-items: center;
    padding: 0.1rem 0.11rem;
    background: #ffffff;
    position: fixed;
    width: 100%;
    bottom: 0;
    .save {
      width: 0.28rem;
      height: 0.43rem;
      background: transparent;
      outline: none;
      border-width: 0;
      margin-bottom: 0.1rem;
      margin-right: 0.11rem;
      img {
        width: 100%;
      }
    }
    .submit {
      flex: 1;
      display: block;
      margin-bottom: 0.1rem;
      line-height: 0.43rem;
      background: linear-gradient(90deg, #fc0324 0%, #f63a66 100%);
      border: none;
      outline: none;
      color: #fff;
      font-size: 0.17rem;
      border-radius: 0.25rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/community/communityEvaluation.vue